import { Directive, HostBinding, HostListener, inject, Input, OnChanges } from '@angular/core';
import { isLinkValue, type LinkValue } from '@front-platform/content-builder';

import { LinkNavigationService } from '@core/services/link-navigation/link-navigation.service';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';

@Directive({
  selector: 'a[link], app-button-atom[link]',
  standalone: true,
})
export class LinkDirective implements OnChanges {
  @HostBinding('attr.href') hrefAttr: string | undefined = '';
  @Input() link?: string | LinkValue;

  private readonly linkNavigation = inject(LinkNavigationService);
  private readonly routerHelper = inject(RouterHelperService);

  ngOnChanges(): void {
    if (this.link == null || this.link === '') {
      this.hrefAttr = this.link as string | undefined;
      return;
    }

    if (isLinkValue(this.link)) {
      // Structured modal links have no navigable href; click handles open().
      this.hrefAttr = undefined;
      return;
    }

    // Preserve query string (e.g. ?catalogId=...) when translating the route path
    const queryIndex = this.link.indexOf('?');
    const path = queryIndex >= 0 ? this.link.slice(0, queryIndex) : this.link;
    const queryString = queryIndex >= 0 ? this.link.slice(queryIndex + 1) : undefined;
    this.hrefAttr = this.routerHelper.translateRoute(path) as string;
    if (queryString !== undefined) {
      this.hrefAttr += '?' + queryString;
    }
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (this.link == null || this.link === '') {
      return;
    }

    if (isLinkValue(this.link)) {
      if (this.link.kind === 'modal') {
        event.preventDefault();
        this.linkNavigation.navigate(this.link);
      }
      return;
    }

    if (
      this.routerHelper.isRelativeMode(this.link) ||
      this.routerHelper.isMailto(this.link) ||
      this.routerHelper.isAnchor(this.link) ||
      (!event.ctrlKey && !this.routerHelper.isLinkExternal(this.link))
    ) {
      event.preventDefault();
      this.linkNavigation.navigate(this.link);
    }
  }
}
